import {
  ArrowUp,
  ArrowRight,
  ArrowLeft,
  CornerUpRight,
  CornerUpLeft,
  CornerDownRight,
  CornerDownLeft,
  RotateCw,
  RotateCcw,
  Flag,
  Navigation,
  Circle,
  ArrowUpRight,
  ArrowUpLeft,
  type LucideIcon,
} from 'lucide-react';

/**
 * Valhalla maneuver types
 * See: https://valhalla.github.io/valhalla/api/turn-by-turn/api-reference/#maneuver-types
 */
export interface ManeuverInfo {
  icon: LucideIcon;
  label: string;
  color?: string;
}

export const MANEUVER_TYPES: Record<number, ManeuverInfo> = {
  0: { icon: Circle, label: 'Точка' },
  1: { icon: Navigation, label: 'Начало маршрута' },
  2: { icon: ArrowUpRight, label: 'Начните движение направо' },
  3: { icon: ArrowUpLeft, label: 'Начните движение налево' },
  4: { icon: Flag, label: 'Вы прибыли', color: '#22c55e' },
  5: { icon: Flag, label: 'Прибытие справа' },
  6: { icon: Flag, label: 'Прибытие слева' },
  7: { icon: ArrowUp, label: 'Продолжайте движение' },
  8: { icon: ArrowUp, label: 'Продолжайте прямо' },
  9: { icon: CornerUpRight, label: 'Немного направо' },
  10: { icon: ArrowRight, label: 'Направо' },
  11: { icon: CornerDownRight, label: 'Резко направо' },
  12: { icon: RotateCw, label: 'Разворот направо' },
  13: { icon: RotateCcw, label: 'Разворот налево' },
  14: { icon: CornerDownLeft, label: 'Резко налево' },
  15: { icon: ArrowLeft, label: 'Налево' },
  16: { icon: CornerUpLeft, label: 'Немного налево' },
  17: { icon: ArrowUp, label: 'Прямо на съезд' },
  18: { icon: CornerUpRight, label: 'Съезд направо' },
  19: { icon: CornerUpLeft, label: 'Съезд налево' },
  20: { icon: CornerUpRight, label: 'Держитесь правее на съезде' },
  21: { icon: CornerUpLeft, label: 'Держитесь левее на съезде' },
  22: { icon: ArrowUp, label: 'Въезд на съезд' },
  23: { icon: ArrowUp, label: 'Въезд на развязку' },
  24: { icon: ArrowUp, label: 'Въезд на развязку' },
  25: { icon: RotateCw, label: 'Круговое движение' },
  26: { icon: RotateCw, label: 'Съезд с кольца' },
  27: { icon: ArrowUp, label: 'На паром' },
  28: { icon: ArrowUp, label: 'С парома' },
  // Roundabouts (maneuver types 26+)
  // These have additional roundabout exit number in the instruction
};

/**
 * Get maneuver info by type
 */
export function getManeuverInfo(type: number): ManeuverInfo {
  return (
    MANEUVER_TYPES[type] || {
      icon: ArrowUp,
      label: 'Продолжайте движение',
    }
  );
}

/**
 * Check if maneuver is a destination type
 */
export function isDestinationManeuver(type: number): boolean {
  return type >= 4 && type <= 6;
}

/**
 * Check if maneuver is a start type
 */
export function isStartManeuver(type: number): boolean {
  return type >= 1 && type <= 3;
}

/**
 * Get appropriate color for maneuver type
 */
export function getManeuverColor(type: number): string {
  if (isDestinationManeuver(type)) return '#22c55e'; // green
  if (isStartManeuver(type)) return '#3b82f6'; // blue
  return '#1e293b'; // slate-800
}
